import AbadRavanShenasiSingle from "./AbadRavanShenasiSingle";

export default function AbadRavanShenasi() {


    return (
        <>
            <AbadRavanShenasiSingle option1="آرام، متمركز، دقیق" option2="پر شور، معاشرتی، خوش سخن" number={1}/>
            <AbadRavanShenasiSingle option1="خلاق، کلی نگر، آینده نگر" option2="ریز نگر، عمل گرا، اندیشه منظم" number={2}/>
            <AbadRavanShenasiSingle option1="خونگرم، دلسوز، کمک رسان" option2="اهل مباحثه، حقیقت گرا، تاجر مسلک" number={3}/>
            <AbadRavanShenasiSingle option1="شوخ طبع، سازشکار، صبور، منعطف" option2="رسمی، جدی، قاطع، قانونمند" number={4}/>
        </>
    )
}